import { DateFilterListItem } from './constants';

export interface DateRange {
  startTime: Date;
  endTime: Date;
}

export enum DateFilterPosition {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export interface DateFilterProps {
  dateRange?: DateRange;
  selectedDateFilterItem?: DateFilterListItem;
  childRenderer?: (
    open: boolean,
    toggle: (nextValue?: any) => void,
    ref: React.MutableRefObject<HTMLButtonElement | null>,
  ) => React.ReactNode;
  position?: DateFilterPosition;
  options?: DateFilterListItem[];
  onDone: (startTime?: Date, endTime?: Date, selectedItem?: DateFilterListItem) => void;
  onToggleFilter?: () => void;

  //mobile-props
  startTime?: Date | null;
  endTime?: Date;
  value?: string;
  onClose?: () => void;
  isOpen?: boolean;
}
